// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"149":"affbf037","276":"b6da55a5","767":"e823892d"}[chunkId] + ".chunk.css";
};